/**
 * Form-related utility functions
 */
/**
 * Extract form IDs from website data
 */
const getFormIdsInWebsiteData = (websiteData) => {
    const formIdsSet = new Set();
    for (const section of websiteData.sections) {
        const newFormIdsSet = _getFormIdsInSectionData(section);
        newFormIdsSet.forEach((id) => formIdsSet.add(id));
    }
    for (const popup of websiteData.popups || []) {
        const newFormIdsSet = _getFormIdsInHTML(popup.content);
        newFormIdsSet.forEach((id) => formIdsSet.add(id));
    }
    return formIdsSet;
};
const _getFormIdsInSectionData = (section) => {
    if (section.type === 'html') {
        return _getFormIdsInHTML(section.content);
    }
    const formIdsSet = new Set();
    const _getFormIdsRecursivly = (obj) => {
        for (const entry of Object.entries(obj)) {
            const [k, v] = entry;
            if (!v)
                continue;
            if ((k === 'formId' || k === 'quizId') && typeof v === 'string') {
                formIdsSet.add(v);
            }
            else if (k === 'formData' && v.formId) {
                formIdsSet.add(v.formId);
            }
            else if (k === 'cta' && Array.isArray(v)) {
                v.forEach((cta) => {
                    if (cta.type === 'form' && cta.value) {
                        formIdsSet.add(cta.value);
                    }
                });
            }
            else if (Array.isArray(v)) {
                v.forEach(_getFormIdsRecursivly);
            }
            else if (typeof v === 'object') {
                _getFormIdsRecursivly(v);
            }
        }
    };
    _getFormIdsRecursivly(section);
    return formIdsSet;
};
const _getFormIdsInHTML = (html) => {
    const formIdsSet = new Set();
    if (!html)
        return formIdsSet;
    // Use regex to find all data-form-id attribute values
    const regex = /data-form-id=["']([^"']+)["']/g;
    let match;
    while ((match = regex.exec(html)) !== null) {
        formIdsSet.add(match[1]);
    }
    return formIdsSet;
};
/**
 * Extract text from Quill delta format
 */
const extractTextFromQuill = (obj, forceArray = false) => {
    if (!obj || !obj.ops)
        return forceArray ? [] : '';
    const texts = obj.ops
        .filter((op) => op.insert && typeof op.insert === 'string')
        .map((op) => op.insert.trim())
        .filter((text) => text.length > 0);
    return forceArray ? texts : texts.join(' ');
};
/**
 * Extract text from Quill and trim whitespace
 */
const extractTextFromQuillTrimmed = (obj, maxLength) => {
    const text = extractTextFromQuill(obj);
    if (maxLength && text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
};
/**
 * Extract search parameters mentioned in section
 */
const extractUsedSearchParamsFromSection = (section) => {
    const searchParams = new Set();
    const extractFromObject = (obj) => {
        if (typeof obj === 'string') {
            // Look for {{param}} patterns
            const matches = obj.match(/\{\{([^}]+)\}\}/g);
            if (matches) {
                matches.forEach((match) => {
                    const param = match.replace(/[{}]/g, '');
                    searchParams.add(param);
                });
            }
        }
        else if (Array.isArray(obj)) {
            obj.forEach(extractFromObject);
        }
        else if (obj && typeof obj === 'object') {
            Object.values(obj).forEach(extractFromObject);
        }
    };
    extractFromObject(section);
    return searchParams;
};

export { _getFormIdsInSectionData, extractTextFromQuill, extractTextFromQuillTrimmed, extractUsedSearchParamsFromSection, getFormIdsInWebsiteData };
//# sourceMappingURL=form.esm.js.map
